import styled from 'styled-components';
import { Menu as SideBarMenu } from 'components/organisms/projects/project-sidebar/menu.style';
import { SubMenu as SpacesSubMenu } from 'components/organisms/templates/projects/spaces/left-nav/sub-menu/styles';
import { ProductiveHeading05 } from 'components/styles';
import { Sider as SiderComponent } from '../sider';

export const Header = styled.div`
  padding: var(--spacing-07) var(--spacing-05) 0;
  padding-left: var(--left-spacing);
  white-space: nowrap;
  ${ProductiveHeading05};
`;

// :TODO Move this to atom with expandable search input
export const SearchInput = styled.div`
  margin: var(--spacing-05) var(--spacing-05) var(--spacing-02)
    var(--spacing-05);
  position: relative;
  box-shadow: var(--shadow-01);
  svg {
    position: absolute;
    right: 16px;
    top: 12px;
  }
  input {
    padding-right: 40px;
  }
`;

export const SubMenu = styled(SpacesSubMenu)`
  &.ant-menu-submenu {
    .ant-menu-item {
      padding-left: 56px !important;
    }
    .ant-menu-submenu-title {
      color: var(--icon-primary);
    }
    .ant-menu-item-icon {
      min-width: 0;
    }
  }
`;
export const Menu = styled(SideBarMenu)`
  margin: var(--spacing-02) 0px;
  ${SubMenu} {
    margin-top: var(--spacing-05);
  }
  ${SubMenu}:last-child {
    margin-bottom: var(--spacing-07);
  }
`;

export const Content = styled.div`
  ${SubMenu} .ant-menu-submenu-title {
    position: sticky;
    top: 0;
    background: var(--white-100);
    z-index: 1;
  }
  .ant-menu-submenu.ant-menu-submenu-selected {
    font-weight: normal;
  }
`;

export const Sider = styled(SiderComponent)`
  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
  }

  ${Content} {
    /* margin-top: var(--spacing-03); */
    overflow-x: hidden;
    overflow-y: auto;
  }
`;
